define([
    'core/urls',
    'moment',
    'components/daterangepicker',
    'core/browser-storage',
    'components/modal',
    'core/iterate',
    'components/pagination',
    'components/search-field',
    'components/fake-progress',
    'components/dropdown',
    'components/request-time-manager',
    'components/metrics',
    'components/custom-encode-uri',
    'components/automation-banner',
    'core/utilities',
],
function (
        urls, 
        moment, 
        drp, 
        browser_storage, 
        modal, 
        iterate, 
        initPagination, 
        initSearchField, 
        FakeProgress, 
        DD, 
        requestTM, 
        keyMetrics,
        customEncodeUri,
        automationBanner,
        utilities
    ) 
{

    let nodes =  {
        resultWrap: document.querySelector(".table-results-wrap"),
        waitMessage: document.querySelector(".wait-message"),
        noResultsTable: document.querySelector(".table-results-wrap .no-results"),
        filterSettings: document.querySelector(".settings-panel.filter-settings"),
        filterSettingsToggle: document.querySelector(".settings-toggle-wrap"),
        filterSettingsToggleLabel: document.querySelector(".settings-toggle-wrap .label"),
        filterStatus: document.querySelector(".filter-status"),
        filtersReset: document.querySelector(".reset-settings"),
        dateStatus: document.querySelector(".page-header.responses .date-range .value"),
        preserveFilters: document.querySelector("#preserveFilters"),
        responsesHeader: document.querySelector(".page-header.responses"),
        campaign: {
            filterList: document.querySelector(".filter-campaigns-list_js"),
            wrap: document.querySelector(".filter-campaigns_js"),
            input: document.querySelector(".filter-campaigns-input_js"),
            btn: document.querySelector(".filter-toggle-campaigns_js"),
            checkers: document.querySelectorAll(".campaign-checker_js"),
            chipsWrap: document.querySelector(".campaigns-chips_js"),
            clearBtn: document.querySelector(".campaigns-clear-btn_js"),
            chips: document.querySelectorAll(".campaign-chip_js"),
        },
        responses: {
            wrap: document.querySelector(".nps-responses_js")
        },
        sentimentsMetrics: [...document.querySelectorAll(".sentiment-grayscale_js .card__content-item")],
        metrics: {
            main: document.querySelector(".metrics-header-wrap.global"),
            wrap: document.querySelector(".metrics-wrap"),
            metricsContainer: document.querySelector(".metrics-wrap .metrics"),
            header: document.querySelector(".page-header.metrics"),
            detractors: document.querySelector(".metrics-nps-det_js"),
            passives: document.querySelector(".metrics-nps-pas_js"),
            promoters: document.querySelector(".metrics-nps-pro_js"),
            result: document.querySelector(".metrics-nps_js"),
            rate: document.querySelector(".metrics-nps-rate_js"),
            status: document.querySelector(".metrics-nps-status_js"),
            responded: document.querySelector(".metrics-nps-responded_js"),
            sent: document.querySelector(".metrics-nps-sent_js"),
            toolTip: document.querySelector(".metrics-nps-tooltip_js"),
            benchmarksToggle: document.querySelector("#toggleBenchmarks"),
        },
        miniMetrics: {
            wrap: document.querySelector(".mini-metrics-wrap"),
            score: document.querySelector(".mini-metrics .score .value"),
            responses: document.querySelector(".mini-metrics .responses .value"),
            promoters: document.querySelector(".mini-metrics .responses .promoters"),
            passives: document.querySelector(".mini-metrics .responses .passives"),
            detractors: document.querySelector(".mini-metrics .responses .detractors"),
            responseRate: document.querySelector(".mini-metrics .response-rate .value"),
        },
        searchField: {
            searchField: document.querySelector(".search-response_js"),
            resetBtn: document.querySelector(".search-response-reset_js"),
            openBtn: document.querySelector(".search-response-open_js"),
            wrap: document.querySelector(".results-search-wrap_js")
        },
        pagination: {
            wrap: document.querySelector(".pagination_js"),
            page: document.querySelector(".pagination_page_js"),
            hole: document.querySelector(".pagination_hole_js")
        },
        selectLimit: document.querySelector(".nps-responses-limit_js"),
        modals: {
            modal: document.querySelector(".modal_js"),
            close: document.querySelector(".modal-close_js"),
            content: document.querySelector(".modal-content_js"),
            title: document.querySelector(".modal-title_js"),
            bg: document.querySelector(".modal-bg_js"),
            blur: [
                document.querySelector(".nps-responses"),
                document.querySelector(".sidebar-nav"),
                document.querySelector(".navigation-top")
            ]
        },
    }

    let metricsComponent = keyMetrics.init(nodes.metrics, "responses");
    metricsComponent.initBenchmarks();
    metricsComponent.adjustMetricsHeight();

    window.addEventListener("resize", metricsComponent.adjustMetricsHeight);
    
    let platform = document.querySelector(".nps-responses").getAttribute('data-platform');
    let pagination;
    let dateRangePicker;
    let preserveFilters = browser_storage.getItem("response-preserve-filters") || false;
    let initialDateRange;

    let dataCacheTimeRemaining = 0;
    let cacheTimer;

    let filtersRendered = false;

    let isAdmin = document.querySelector(".nps-responses.sb-page").dataset.isAdmin === "True" ? true : false;
    
    var optimizedResize = (function () {

        var callbacks = [],
            running = false;

        let windowWidth = window.innerWidth;

        // fired on resize event
        function resize() {

            if(windowWidth !== window.innerWidth) {
                windowWidth = window.innerWidth;

                if (!running) {
                    running = true;

                    if (window.requestAnimationFrame) {
                        window.requestAnimationFrame(runCallbacks);
                    } else {
                        setTimeout(runCallbacks, 66);
                    }

                    setSettingsHeight();
                }
            }
        }

        // run the actual callbacks
        function runCallbacks() {
            callbacks.forEach(function (callback) {
                callback();
            });

            running = false;
        }

        // adds callback to loop
        function addCallback(callback) {
            if (callback) {
                callbacks.push(callback);
            }
        }

        return {
            // public method to add additional callback
            add: function (callback) {
                if (!callbacks.length) {
                    window.addEventListener('resize', resize);
                }
                addCallback(callback);
            }
        }
    }());

    let loaderElement = document.querySelector(".marketing-loader");
    let hint = loaderElement.querySelector(".loader-bar-wrap_hint");

    hint.innerText = "Your results are loading. Please wait.";
    
    let initialLoader = new FakeProgress(
        document.querySelector(".marketing-loader .loader-bar-wrap-bar")
    );

    let contactsProgress = new FakeProgress(
        document.querySelector(".loader-bar-wrap_contacts_js .loader-bar-wrap-bar")
    );

    let filtersProgress = new FakeProgress(
        document.querySelector(".filter-settings .loader-bar")
    );

    var createdModal = modal.create(nodes.modals, function () {});
    
    nodes.waitMessage.classList.add("disabled");

    // this is the data used to create the filter options
    let filterData = {
        sentiment: {
            values: [
                {id: "1", name: "Promoters"},
                {id: "0", name: "Passives"},
                {id: "-1", name: "Detractors"}
            ],
        },
        comment: {
            values: [
                {id: '1', name: "With comments only" },
                {id: '2', name: "Without comments only"},
                {id: '3', name: "With marketing permission"},
                {id: '4', name: "Published on the Website Widget"}
            ],
            type: "radio",
            default: "0",
        },
    }

    // these are the current chosen filters - the rest of the values get populated after the getFilters() call
    let filterParams = {
        comment: "0",
        sentiment: [],
    }

    // params for sorting / search / pagination and non-filter category filtering
    let queryParams = {
        q: "",
        limit: 10,
        page: 1,
        sort: {date: "desc"},
        platform,
    }

    // params specific to date selections
    let dateParams = {
        preset: "Last 90 days",
        date: null,
    }

    let resetFilterParams = {
        comment: "0",
    }

    //filters entities
    function initDateRangePicker(cb) {

        if(preserveFilters === "true" || preserveFilters === true) {
            dateParams = JSON.parse(browser_storage.getItem("response-date-params"));
        }

        var options = {
            format: {
                input: 'DD.MM.YYYY'
            },
            days_array: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
        };

        var response = {};

        if (dateParams.preset) {
            options.preset_label = dateParams.preset;
            generateDateRange();
        } else {
            options.start_date = moment(dateParams.date[0]);
            options.end_date = moment(dateParams.date[1]);
            generateDateRange();
            drp.set(options.start_date, options.end_date);
        }

        function generateDateRange() {
            drp.create(options, function () {
                response.preset = drp.getPreset();
                response.date = [drp.getStartDate().format('YYYY-MM-DD'), drp.getEndDate().format('YYYY-MM-DD')];
                cb(response);
            });
        }

        return {
            reset: drp.reset,
            getDate: function () {
                return [drp.getStartDate().format('YYYY-MM-DD'), drp.getEndDate().format('YYYY-MM-DD')];
            }
        }
    }

    function initLimitFilter(select, cb, data) {
        var payload = data.next;
        select.value = payload;
        select.addEventListener('change', function (e) {
            cb(e.target.value);
        });
        return {
            reset: function () {

                payload = "10";
                select.value = payload;
            }
        }
    }

    //request
    let startedGetContacts = false;
    let dataTimeManager = new requestTM();

    function getData(callback, initialLoad) {
        loaderElement.classList.remove("disabled");
        initialLoader.startLoading(15);

        // gather saved filter settings on page load
        if(filtersRendered && preserveFilters === "true" && initialLoad) {
            filterParams = JSON.parse(browser_storage.getItem("response-filter-params"));
            dateParams = JSON.parse(browser_storage.getItem("response-date-params"));
        }
        
        saveFilters();            
        
        if (startedGetContacts) {
            dataTimeManager.abort({success: true});
        } else {
            contactsProgress.wrap.classList.remove("disabled");
            contactsProgress.startLoading(10);
            filtersProgress.node.classList.remove("disabled");
            filtersProgress.startLoading(10);
            nodes.resultWrap.classList.add("loading");
            nodes.waitMessage.classList.remove("disabled");
            nodes.noResultsTable.classList.add("hide");
            startedGetContacts = true;
        }

        let link = urls['nps:responses-data'](dateParams.date[0], dateParams.date[1]);

        dataTimeManager.start((error) => {
            startedGetContacts = false;
            contactsProgress.loadFinish();
            filtersProgress.loadFinish();
            createdModal.open({
                class: "error-modal",
                content: error_modal.innerHTML,
                title: ""
            }, function (el) {
                el.querySelector(".button-primary").addEventListener("click", createdModal.close);
            });

        });

        contactsProgress.reset();
        filtersProgress.reset();

        let dataRequest = () => {
            var xhr = new XMLHttpRequest();

            xhr.open("GET", link + "?data=" + encodeURIComponent(JSON.stringify({...filterParams, ...queryParams})), true);
            dataTimeManager.addXHR(xhr); //FIXME Should be placed after xhr.open to work in IE 11
            xhr.setRequestHeader("Content-Type", "application/json");

            xhr.onreadystatechange = function () {
                let data = {};

                try {
                    data = JSON.parse(xhr.responseText);
                } catch (e) {
                    data = {success: false};
                }

                switch (true) {
                    case xhr.status === 500:
                        startedGetContacts = false;
                        contactsProgress.loadFinish();
                        filtersProgress.loadFinish();
                        loaderElement.classList.add("disabled");
                        initialLoader.loadFinish();
                        dataTimeManager.abort();
                        nodes.resultWrap.classList.remove("hide");
                        break;

                    case xhr.status === 0:
                        data = {success: false};
                        return;

                    case xhr.status !== 200:
                        data = {success: false};
                        startedGetContacts = false;
                        break;
                }

                new Promise(function(resolve) { 
                    let timeout = data.success ? 300 : 0
                    setTimeout(resolve, timeout); 
                }).then(function() { 
                    if (data.success) {
                        clearInterval(cacheTimer);

                        dataCacheTimeRemaining = globals.settings.NPS_CACHE_TTL;

                        cacheTimer = setInterval(() => {
                            dataCacheTimeRemaining --;

                            if(dataCacheTimeRemaining === 0) {
                                clearInterval(cacheTimer);
                            }
                        }, 1000);

                        pagination.set(data.page_info);
                        renderResponses(data.responses, nodes.responses.wrap);
                        renderMetrics(data.metrics, data.benchmarks);

                        nodes.resultWrap.classList.remove("loading");
                        nodes.resultWrap.classList.remove("hide");

                        queryParams.numPages = data.page_info.num_pages;
                        startedGetContacts = false;

                        loaderElement.classList.add("disabled");
                        initialLoader.loadFinish();

                        dataTimeManager.abort({success: true});
                        contactsProgress.loadFinish();
                        contactsProgress.wrap.classList.add("disabled");
                        filtersProgress.loadFinish();
                        filtersProgress.node.classList.add("disabled");
                        nodes.pagination.wrap.style.display = "flex";
                        nodes.waitMessage.classList.add("disabled");

                        //Parsing filters                            
                        if(!filtersRendered) {
                            if (platform === "cw") {
                                data.filters.company_statuses = data.filters.company_statuses || ["active","unactive"];
                            }

                            iterate(data.filters, (value, key) => {
                                filterData[key] = {
                                    values: value,
                                    type: "search",
                                }
                                if(preserveFilters === false || preserveFilters === "false") {
                                    filterParams[key] = [];
                                }
                            });

                            renderFilters(data);
                        }

                        if(callback) {
                            callback(data); 
                        }
                    }
                });
            };

            xhr.send();

        };
        
        dataTimeManager.interval(dataRequest);

    };

    function renderMetrics(metrics, benchmarks) {
        if(browser_storage.getItem("responses-metrics-collapse-v2") === "true") {
            nodes.miniMetrics.score.classList.add("toggling");
            nodes.miniMetrics.responses.classList.add("toggling");
            nodes.miniMetrics.responseRate.classList.add("toggling");
        } else {
            nodes.metrics.result.classList.add("toggling");
            nodes.metrics.status.classList.add("toggling");
            nodes.metrics.rate.classList.add("toggling");
        }

        // large metrics
        nodes.metrics.detractors.innerText = metrics.nps.detractors;
        nodes.metrics.passives.innerText = metrics.nps.passives;
        nodes.metrics.promoters.innerText = metrics.nps.promoters;
        nodes.metrics.result.innerText = metrics.nps.result;
        nodes.metrics.responded.innerText = metrics.response_stats.responded;
        nodes.metrics.status.innerText = metrics.response_stats.responded;
        nodes.metrics.sent.innerText = metrics.response_stats.sent;

        // mini metrics
        nodes.miniMetrics.detractors.innerText = metrics.nps.detractors;
        nodes.miniMetrics.passives.innerText = metrics.nps.passives;
        nodes.miniMetrics.promoters.innerText = metrics.nps.promoters;
        nodes.miniMetrics.score.innerText = metrics.nps.result;
        nodes.miniMetrics.responses.innerText = metrics.response_stats.responded;

        if(!metrics.response_stats.rate || metrics.response_stats.rate == '0.0') {
            nodes.metrics.rate.innerText = 'N/A';
            nodes.miniMetrics.responseRate.innerText = 'N/A';
        } else {
            nodes.metrics.rate.innerHTML = `${metrics.response_stats.rate}<div class="symbol">%</div>`;
            nodes.miniMetrics.responseRate.innerHTML = metrics.response_stats.rate;
        }

        setTimeout(() => {
            if(browser_storage.getItem("responses-metrics-collapse-v2") === "true") {
                nodes.miniMetrics.score.classList.remove("toggling");
                nodes.miniMetrics.responses.classList.remove("toggling");
                nodes.miniMetrics.responseRate.classList.remove("toggling");
            } else {
                nodes.metrics.result.classList.remove("toggling");
                nodes.metrics.status.classList.remove("toggling");
                nodes.metrics.rate.classList.remove("toggling");
            }
        }, 100)
        
        if (metrics.response_stats.sent) {
            nodes.metrics.wrap.classList.remove("show-tooltip");
        } else {
            nodes.metrics.wrap.classList.add("show-tooltip");
        }

        // benchmarks 
        let scoreBenchmarks = document.querySelector(".card.main-score .benchmarking");
        let responseRateBenchmarks = document.querySelector(".card.response-rate .benchmarking");

        let applyBenchmarks = (benchmarkWrapper, type) => {
            let mainScoreBenchmark = benchmarks[`${type}_median`];
            let topTenBenchmark = benchmarks[`top_${type}_median`];

            // benchmark elements
            let allCompaniesElement = benchmarkWrapper.querySelector(".bm-score.all");
            let topTenElement = benchmarkWrapper.querySelector(".bm-score.top10");
            let mainDeltaElement = benchmarkWrapper.querySelector(".diff.all");
            let topDeltaElement = benchmarkWrapper.querySelector(".diff.top10");

            mainDeltaElement.classList.remove("negative", "positive");
            topDeltaElement.classList.remove("negative", "positive");
            allCompaniesElement.innerHTML = "N/A";
            topTenElement.innerHTML = "-";
            mainDeltaElement.innerHTML = "N/A";
            topDeltaElement.innerHTML = "N/A";

            if(mainScoreBenchmark) {
                let percentSign = type === "response_rate" ? "%" : "";
                allCompaniesElement.innerText = mainScoreBenchmark.toFixed(1) + percentSign;
                
                if(topTenBenchmark) {
                    topTenElement.innerText = topTenBenchmark.toFixed(1) + percentSign;
                }

                // deltas
                let customerScore = type === "score" ? metrics.nps.result : metrics.response_stats.rate; 
                
                let renderDeltas = (element, benchmarkScore) => {
                    let delta = customerScore - benchmarkScore;

                    let symbol = "";

                    if(Math.floor(delta) === 0) {
                        delta = 0;
                    }

                    if(Math.floor(delta) < 0) {
                        element.classList.add("negative");
                        symbol = "-";
                    }

                    if (Math.floor(delta) > 0) {
                        element.classList.add("positive");
                        symbol = "+";
                    }

                    element.innerHTML = `<div class="symbol">${symbol}</div>${Math.abs(delta).toFixed(1)}`;
                }

                // apply delta values for All Companies
                renderDeltas(mainDeltaElement, mainScoreBenchmark);
                
                if(topTenBenchmark) {
                    // apply delta values for Top 10%
                    renderDeltas(topDeltaElement, topTenBenchmark);
                }
            }

            
        }

        // apply benchmarks to CSAT Main Score
        applyBenchmarks(scoreBenchmarks, "score");
        // apply benchmarks to CSAT Response Rate
        applyBenchmarks(responseRateBenchmarks, "response_rate");

        metricsComponent.adjustMetricsHeight();
        
    }

    let marketingPermissionsValid = document.querySelector(".result").getAttribute("data-has-marketing-permissions") === "False" ? false : true;

    let ajaxPublishResponse = (event) => {

        let xhr = new XMLHttpRequest();

        let id = event.target.getAttribute("data-response-id");
        let company = event.target.getAttribute("data-company");
        let contact = event.target.getAttribute("data-contact");
        
        if (event.target.checked) { // publish
            params = {
                "resp_id" : id,
                "company" : company,
                "contact" : contact
            }
            xhr.open('GET', `${urls['nps:publish']()}?data=${encodeURIComponent(JSON.stringify(params))}`, true);
        } else { // unpublish
            xhr.open('GET', urls['nps:un-publish'](id), true);
        }

        xhr.send();
    }

    let deleteResponse = (id) => {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', urls['nps:delete-response'](id), true);

        xhr.onreadystatechange = () => {

            if (xhr.readyState !== 4) {
                return;
            }
            
            let data;

            try {
                data = JSON.parse(xhr.responseText);
            } catch (e) {
                data = {success: false};
            }

            if(!data.success) {
                let deleteErrorModal = document.querySelector(".modal-template-delete-error_js");
                createdModal.open({
                    class: "error-modal",
                    content: deleteErrorModal.innerHTML,
                    title: ""
                }, function (el) {
                    el.querySelector(".button-primary").addEventListener("click", createdModal.close);
                });

                return;
            }
            
            let row = document.querySelector(`tr[data-response-id="${id}"`);
            row.classList.add("deleted");

            setTimeout(() => {
                row.remove();
                getData();
            }, 400)
        }

        xhr.send();
    }

    function renderResponses(responses, responsesNode) {

        let tbody = document.querySelector(".contacts-table tbody");
        tbody.innerHTML = "";

        if (responses.length === 0) {
            document.querySelector(".table-pagination__page span").innerText = "0";
            nodes.noResultsTable.classList.remove("hide");
        }

        iterate(responses, function (item, i) {
            let oddEven = i % 2 === 0 ? 'even' : 'odd';
            let className;
            switch (item.reaction_type) {
                case 0:
                    className = "warning";
                    break;
                case 1:
                    className = "primary";
                    break;
                case -1:
                    className = "danger";
                    break;
            }
            let more = "";
            let comment = item.comment || "";
            let checkmark = item.score > 8 ? '<span class="checkmark-svg"></span>' : '<span class="no-permissions">&times;</span>'
            let marketingPermissionsMessage = comment === "" ? '–<div class="tooltip"><br>No comment provided<br><br></div>' : '-';

            let publishedToggle = (state, id, company, fullName) => ( 
                `<div class="mini-toggle">
                    <input id="publishReview_${id}" class="publish-toggle" type="checkbox" data-company="${company}" data-contact="${fullName}" data-response-id="${id}" ${state ? 'checked' : ''}>
                    <label for="publishReview_${id}"></label>
                </div>`
            )

            let publishTooltip = item.comment ? '<div class="sb-tooltip">Marketing permission not provided' : '<div class="sb-tooltip no-comment">Comment not provided</div>';

            let publishColumn = '';
            let deleteColumn = '';

            if(isAdmin) {
                publishColumn = `
                    <td class="publish-review tooltip-wrap ${marketingPermissionsValid ? '' : 'invalid'}">
                        ${item.has_marketing_permission ? publishedToggle(item.is_published, item.resp_id, item.company, item.full_name) : `–${publishTooltip}`}
                    </td>
                `;

                deleteColumn = `
                    <td>
                        <div data-id="${item.resp_id}" class="remove-response tooltip-wrap">
                            <div class="icon glyphicons glyphicons-remove-sign"></div>
                            <div class="sb-tooltip">
                                Removing a response will alter your NPS Score and Response Rate
                            </div>
                        </div>  
                        <div data-id="${item.resp_id}" class="remove-response-confirm hide">
                            Delete?
                            <div class="options">
                                <span data-id="${item.resp_id}" class="yes">Yes</span>
                                <span data-id="${item.resp_id}" class="no">No</span>
                            </div>
                        </div>
                    </td>
                `;
            }

            let html = `
                    <td class="score-td"><div class="td-with-image"><img src="${item.sentiment}"><div>${item.score} </div></div></td>
                    <td class="full-name-td">${utilities.sanitizeData(item.full_name)}</td>
                    <td class="company-td">${utilities.sanitizeData(item.company) || '–'}</td>
                    <td class="date">${moment(item.last_modified).format('DD MMM YYYY')}</td>
                    ${publishColumn}
                    ${deleteColumn}
            `;

            let tr = document.createElement("tr");
            tr.setAttribute("data-response-id", item.resp_id);
            tr.classList.add(oddEven);
            tr.innerHTML = html;

            let removeButton = tr.querySelector(".remove-response");

            if(removeButton) {
                tr.querySelector(".remove-response").addEventListener("click", (event) => {
                    event.currentTarget.classList.add("hide");
                    event.currentTarget.parentElement.querySelector(".remove-response-confirm").classList.remove("hide");
                });
    
                tr.querySelector(".remove-response-confirm .yes").addEventListener("click", (event) => {
                    deleteResponse(event.target.getAttribute("data-id"));
                });
    
                tr.querySelector(".remove-response-confirm .no").addEventListener("click", (event) => {
                    let id = event.target.getAttribute("data-id");
                    document.querySelector(`.remove-response[data-id="${id}"]`).classList.remove("hide");
                    document.querySelector(`.remove-response-confirm[data-id="${id}"]`).classList.add("hide");
                });
            }

            tbody.appendChild(tr);

            let commentRow = '';
            let columnCount = isAdmin ? 6 : 4;

            if(comment) {
                commentRow = document.createElement("tr");
                commentRow.classList.add("comment-row");
                commentRow.innerHTML = `
                    <td class="comment-td" colspan=${columnCount}>
                        <div class="comment-wrapper ${className}">
                            <div class="comment-block">${comment}</div>
                            <a class="more button-tertiary">More</a>
                        </div>
                    </td>`;

                tbody.appendChild(commentRow);

                let flag = false;

                commentRow.querySelector(".more").addEventListener("click", function () {
                    let wrap = commentRow.querySelector(".comment-block");
                    if (!flag) {
                        flag = true;
                        wrap.classList.add("open")
                        this.innerText = "less";
                    } else {
                        wrap.classList.remove("open")
                        flag = false;
                        this.innerText = "more";
                    }
                });
            }
        });

        iterate(tbody.querySelectorAll(".publish-toggle"), (toggle) => {
            toggle.addEventListener("change", ajaxPublishResponse);
        });

        iterate(tbody.querySelectorAll(".comment-td") || [], (wrap) => {
            let node = wrap.querySelector(".comment-block");
            if (node.offsetWidth < 800) {
                wrap.parentElement.querySelector(".more").style.display = "none";
            }
        });
    }


    let startedFilter;
    let error_modal = document.querySelector(".modal-template-error_js");

    // this object also acts as the source of priority/order of filter rendering
    let filterNameMapping = {
        sentiment: {
            plural: "Scores",
            singular: "Score",
        },
        campaigns: {
            plural: "Campaigns",
            singular: "Campaign",
        },
        comment: {
            plural: "Responses",
            singular: "Comment",
        },
        companies: {
            plural: "Companies",
            singular: "Company",
        },
        company_statuses: {
            plural: "Company Statuses",
            singular: "Company Status",
        },
        company_types: {
            plural: "Company Types",
            singular: "Company Type",
        },
        contact_types: {
            plural: "Contact Types",
            singular: "Contact Type",
        },
        titles: {
            plural: "Contact Titles",
            singular: "Contact Title",
        },
        locations: {
            plural: "Locations",
            singular: "Location",
        },
        classifications: {
            plural: "Classifications",
            singular: "Classification",
        },
        primaries: {
            plural: "Types",
            singular: "Primary Contact",
        },
        marketing_groups: {
            plural: "Marketing Groups",
            singular: "Marketing Group",
        },
    }

    let closeAllSelectors = (currentId) => {
        let selectors = document.querySelectorAll(".filter-wrap .selector.active");

        selectors.forEach(selector => {
            if(currentId) {
                // exclude current selector if required
                if(selector.getAttribute("data-id") !== currentId) {
                    selector.classList.remove("active");
                }
            } else {
                selector.classList.remove("active");
            }
        })
    }

    // display filter status at top of section in plain english
    let updateFilterStatus = () => {
        let filterCount = 0;
        let categories = [];

        iterate(filterParams, (value, key) => {
            if(Array.isArray(value)) {
                if(value.length) {
                    filterCount += value.length;
                    categories.push(filterNameMapping[key].singular);
                }
            }

            // comment is a radio selection - if anything but 0 is selected, it is considered filtered
            if(key === 'comment' && value !== "0") {
                filterCount ++;
                categories.push(filterNameMapping[key].singular);
            }
        })

        let message = "No filters selected";

        if(filterCount > 0) {
            let buildCategoryGrammar = () => {
                if(categories.length === 1) return `<strong>${categories.toString()}</strong>`;
                
                let oxfordComma = categories.length === 2 ? ' ' : ', ';
                let lastCategory = categories.pop();
                return `<strong>${categories.join('</strong>, <strong>')}</strong>${oxfordComma}and <strong>${lastCategory}</strong>`;
            }
            
            let categoryText = categories.length < 4 ? buildCategoryGrammar() : `<strong>${categories.length} categories</strong>`
            let filterText = filterCount > 1 ? 'filters' : 'filter';

            message = `<strong>${filterCount}</strong> active ${filterText} in ${categoryText}`

            nodes.filterStatus.classList.add("active")
        } else {
            nodes.filterStatus.classList.remove("active")
        }

        nodes.filterStatus.innerHTML = message;

        setSettingsHeight();
    }

    // deselect filter chip
    let deselectFilter = (filterId, categoryId) => {
        let filterWrap = document.querySelector(`.filter-wrap[data-id='${categoryId}']`)
        let filterSelections = filterWrap.querySelector(".selections");
        let selectionElement = filterSelections.querySelector(`[data-id='${filterId}']`);
        let filterOptionElement = filterWrap.querySelector(`.filter-options .option[data-id='${filterId}']`)
        let filterType = filterWrap.getAttribute("data-type");

        // deselect filter option in dropdown
        filterOptionElement.classList.remove("selected");
        // remove selection
        selectionElement.remove();

        if(filterType === "radio") {
            let defaultValue = filterData[categoryId].default;
            filterParams[categoryId] = defaultValue;
            filterSelections.querySelector(".selection.all").classList.remove("hide");
        } else {
            // remove filter selection from params
            filterParams[categoryId] = filterParams[categoryId].filter(item => item !== decodeURIComponent(filterId));

            // show the 'all' selection if no other filters selected
            if (!filterParams[categoryId].length) {
                filterSelections.querySelector(".selection.all").classList.remove("hide");
            }
        }

        // re-activate filter option in dropdown
        filterWrap.querySelector(`.filter-options .option[data-id='${filterId}']`).classList.remove("selected");

        updateFilterStatus();
        getData();
    }

    // toggle the filter selection in dropdown
    let toggleFilter = (chosenFilterElement, categoryId, togglingPreset) => {
        let filterId = chosenFilterElement.getAttribute("data-id");
        let filterWrap = document.querySelector(`.filter-wrap[data-id='${categoryId}']`)
        let filterSelections = filterWrap.querySelector(".selections");
        let filterType = filterWrap.getAttribute("data-type");

        if (chosenFilterElement.classList.contains("selected")) {
            deselectFilter(filterId, categoryId)
            return;
        }
        
        if (!filterParams[categoryId].length || filterType === "radio" || togglingPreset) {
            // hide the 'all' selection if not already hidden
            filterSelections.querySelector(".selection.all").classList.add("hide");
        }

        // add filter selection to filter params
        if (filterType === "radio"){
            // clear previous selections for radio type options
            if(!togglingPreset) filterParams[categoryId] = filterId;
            let dropdownSelection = filterWrap.querySelector(".option.selected");
            let selectedChip = filterWrap.querySelector(".selection:not(.all)");
            if(dropdownSelection) dropdownSelection.classList.remove("selected");
            if(selectedChip) selectedChip.remove();
        } else {
            if(!togglingPreset) filterParams[categoryId].push(decodeURIComponent(filterId));
        }

        // add 'selected' state to filter option in dropdown
        chosenFilterElement.classList.add("selected");

        // create new filter chip
        let newSelectionElement = document.createElement("div");
        newSelectionElement.classList.add("selection");
        newSelectionElement.setAttribute("data-id", filterId)
        newSelectionElement.innerHTML = `${chosenFilterElement.innerText}<span class="remove">✕</div>`;

        // add deselect filter event listener
        newSelectionElement.addEventListener("click", (event) => {
            deselectFilter(filterId, categoryId)
        });

        // add new filter to selections
        filterSelections.prepend(newSelectionElement);

        updateFilterStatus(); 

        if(!togglingPreset) {
            getData();
        }
    }

    let clearSearch = (categoryId) => {
        let search = document.querySelector(`.filter-wrap .selector[data-id="${categoryId}"] .filter-search`);
        if(!search) return;
        
        search.value = '';

        //simulate input event for search to trigger event listener
        let event = document.createEvent('Event');
        event.initEvent('input', true, true);
        search.dispatchEvent(event);
    }

    let filterEventListeners = () => {
        let allSelectors = document.querySelectorAll(".filter-wrap .selector");

        allSelectors.forEach(selector => {
            let categoryId = selector.getAttribute("data-id");
            let search = selector.querySelector(".filter-search");

            selector.querySelector(".filter-name").addEventListener("click", () => {
                closeAllSelectors(categoryId);
                if(selector.classList.contains("active")) {
                    selector.classList.remove("active");
                }else {
                    clearSearch(categoryId);
                    selector.classList.add("active");
                }
            })

            let options = selector.querySelectorAll(".filter-options .option");

            options.forEach(option => {
                option.addEventListener("click", () => {
                    toggleFilter(option, categoryId);
                })
            })

            // add filter search
            if(search) {
                search.addEventListener("input", (event) => {   
                    let results = false;               
                    
                    options.forEach(option => {
                        let match = option.innerText.toLowerCase().indexOf(event.target.value.toLowerCase());
                        if(match > -1) {
                            option.classList.remove("hide");
                            results = true;
                        } else {
                            option.classList.add("hide");
                        }
                    })

                    let noResults = selector.querySelector(".no-results");
                    results ? noResults.classList.add("hide") : noResults.classList.remove("hide");
                })
            };
        })

        nodes.filterSettings.addEventListener("click", (event) => {
            if(!event.target.classList.contains('selector') && !event.target.classList.contains('filter-name') && !event.target.classList.contains('filter-search')) {
                closeAllSelectors();
            }
        })            
    }

    let showPreservedFilters = () => {
        if(preserveFilters === "false") return;

        let activeFilters = false;

        iterate(filterParams, (selections, category) => {
            if((!filterData[category].type || filterData[category].type === "search") && filterParams[category].length > 0) {
                filterParams[category].forEach(selection => {
                    let toggleOption = document.querySelector(`.selector[data-id='${category}'] .filter-options .option[data-id='${encodeURIComponent(selection)}']`);
                    toggleFilter(toggleOption, category, true);
                    activeFilters = true;
                })
            }

            if(filterData[category].type === "radio" && filterParams[category] !== "0") {
                let toggleOption = document.querySelector(`.selector[data-id='${category}'] .filter-options .option[data-id='${selections}']`);
                toggleFilter(toggleOption, category, true);
                activeFilters = true;
            }
        });            

        // if(activeFilters) {
        //     nodes.filterSettingsToggle.classList.add("active");
        //     nodes.filterSettingsToggleLabel.innerText = "Hide Filters";
        // }

        // render saved date range
        let status = dateParams.preset ? dateParams.preset.toLowerCase() : `${moment(dateParams.date[0]).format('MMM DD, YYYY')} - ${moment(dateParams.date[1]).format('MMM DD, YYYY')}`;
        nodes.dateStatus.innerText = status;
    }

    let renderFilters = (filters) => {
        let output = '';
        
        // iterate through filterNameMapping to determine correct order of filters
        iterate(filterNameMapping, (value, key) => {
            // only render filters that have been returned with data
            if(filterData[key]) {
                let options = filterData[key];
                let optionList = typeof(options) === 'object' ? options.values : options;

                let filterOptions = optionList.map(option => { 
                    let name = "";
                    let id = "";
                    
                    if(option && option.name) {
                        name = utilities.sanitizeData(option.name);
                    } else if(option) {
                        name = utilities.sanitizeData(option);
                    }

                    if(option && option.id) {
                        id = option.id;
                    } else if(option) {
                        id = encodeURIComponent(option);
                    }
                    
                    // We have to encode filter names when storing them as data  
                    // attributes, so they don't get converted to HTML in rare cases.
                    // Then we decode them when adding the data to the filter params.
                    return `<div class="option" data-id="${id}">${name}</div>`
                }).join('')

                let search = options.type === 'search' ? `
                    <div class="search-wrap">
                    <input class='filter-search' type="text" placeholder="Search ${filterNameMapping[key].plural}">
                </div>` : '';

                output += `
                    <div class="filter-wrap" data-type="${options.type}" data-id="${key}">
                        <div class="selector" data-id="${key}">
                            <div class="filter-name">
                                ${filterNameMapping[key].singular}
                            </div>
                            <div class="filter-options">
                                ${search}
                                <div class="options-wrap">
                                    ${filterOptions}
                                </div>
                                <p class="no-results hide">No results found</p>
                            </div>
                        </div>
                        <div class="selections"><div class="selection all">All ${filterNameMapping[key].plural}</div></div>
                    </div>
                `
            }                
        })

        nodes.filterSettings.querySelector(".all-filters").innerHTML = output;

        filterEventListeners();
        showPreservedFilters();
        setSettingsHeight(true);

        filtersRendered = true;
    }

    let getFilters = () => {

        nodes.pagination.wrap.style.display = "none";

        loaderElement.classList.remove("disabled");
        initialLoader.startLoading(15);

        return new Promise((res, rej) => {
            var xhr = new XMLHttpRequest();

            xhr.open('GET', urls['nps:response-tss-filters'](), true);

            xhr.send();

            xhr.onload = function () {
                if (xhr.status != 200) {
                    createdModal.open({
                        class: "error-modal",
                        content: error_modal.innerHTML,
                        title: ""
                    }, function (el) {
                        el.querySelector(".button-primary").addEventListener("click", createdModal.close);
                    });
                    rej();
                } else {
                    var data = JSON.parse(xhr.responseText);
                    canvas.classList.remove("disabled");
                    res(data);
                }
            };
        });
    }

    let body = document.querySelector(".nps-responses-body");
    let canvas = document.querySelector(".canvas");

    let createResponsesTable = () => {

        let resultsTable = document.querySelector(".result");

        let table = document.createElement('table');
        table.classList.add("contacts-table");

        let arrowHtml = '<img class="select-arrow-icon" src="/static/icons/down.svg" alt="">';

        let permissionsTooltip = marketingPermissionsValid ? '' : (
            '<div class="tooltip">You can enable marketing permissions for your reviews when you create or manage NPS campaigns</div>');


        let publishHeader = '';
        let deleteHeader = '';

        if(isAdmin) {
            publishHeader = `
                <td class="${marketingPermissionsValid ? 'sortable' : 'invalid'}"
                    data-id="is_published">
                        Publish Comment&nbsp;${marketingPermissionsValid ? arrowHtml : ''}
                        ${permissionsTooltip}
                </td>
            `;

            deleteHeader = `
                <td class="remove-response center">Delete</td>
            `
        }

        const tableHtml = `
            <thead>
                <tr>
                    <td class="sortable asc score-td" data-id="score">Score ${arrowHtml}</td>
                    <td class="sortable asc full-name-td" data-id="full_name">Contact name ${arrowHtml}</td>
                    <td class="sortable asc company-td" data-id="company">Company ${arrowHtml}</td>
                    <td class="sortable desc date-td active" data-id="date">Date ${arrowHtml}</td>
                    ${publishHeader}
                    ${deleteHeader}
                </tr>
            </thead>
            <tbody></tbody>`;

        table.innerHTML = tableHtml;

        resultsTable.appendChild(table);

        table.querySelector("thead tr").addEventListener("click", (e) => {

            let el = e.target;
            let key = el.getAttribute("data-id");

            if (key && el.classList.contains("sortable")) {
                let isDesc = el.classList.contains("desc");
                let isAsc = el.classList.contains("asc");

                if (isDesc || isAsc) {
                    queryParams.sort = isAsc ? {[key]: 'desc'} : {[key]: 'asc'};
                } else {
                    queryParams.sort = {[key]: 'asc'};
                }

                getData(() => {
                    iterate(document.querySelectorAll(".sortable"), (node) => {
                        node.classList.remove("asc");
                        node.classList.remove("desc");
                        node.classList.remove("active");
                    });

                    el.classList.add("active");

                    if (queryParams.sort[key] === "asc") {
                        el.classList.add("asc");
                    } else {
                        el.classList.add("desc");
                    }
                });
            }
        });
    }

    const setSettingsHeight = (isPageLoad) => {
        let isHidden = nodes.filterSettings.classList.contains("hide");
        //disable transitions while adjusting height value
        nodes.filterSettings.classList.add("no-transition");
        // momentarily show and save settings height so hide transition works
        nodes.filterSettings.classList.remove("hide");
        nodes.filterSettings.style.height = null;
        settingsHeight = nodes.filterSettings.offsetHeight;
        nodes.filterSettings.style.height = `${settingsHeight}px`;

        if(isPageLoad || isHidden) {  // don't override user's open/close settings
            nodes.filterSettings.classList.add("hide");
        }
        
        setTimeout(() => {
            nodes.filterSettings.classList.remove("no-transition");
        }, 1500);
    }

    let saveFilters = () => {
        browser_storage.setItem("response-filter-params", JSON.stringify(filterParams));
        browser_storage.setItem("response-date-params", JSON.stringify(dateParams));
    }

    let initPreserveFilters = () => {
        nodes.preserveFilters.addEventListener("change", (event) => {
            if(event.target.checked) {
                saveFilters();
                preserveFilters = true;
                browser_storage.setItem("response-preserve-filters", true);
            } else {
                browser_storage.removeItem("response-filter-params");
                browser_storage.removeItem("response-date-params");
                browser_storage.setItem("response-preserve-filters", false);
                preserveFilters = false;
            }
        })

        if(preserveFilters === "true") {
            nodes.preserveFilters.checked = true;
        }
    }

    let initSettingsReset = () => {
        nodes.filtersReset.addEventListener("click", () => {
            
            dateParams = {
                preset: "Last 90 days",
                date: initialDateRange,
            }
            
            iterate(filterParams, (value, key) => {
                if(resetFilterParams[key]) {
                    filterParams[key] = resetFilterParams[key]
                } else {
                    filterParams[key] = [];
                } 
            });
            
            saveFilters();

            document.querySelectorAll(".selection:not(.all)").forEach(selection => {
                selection.parentElement.querySelector(".all").classList.remove("hide");
                selection.remove();
            })

            document.querySelectorAll(".option.selected").forEach(option => {
                option.classList.remove("selected");
            })

            nodes.filterStatus.classList.remove("active");
            nodes.filterStatus.innerText = "No filters selected";

            dateRangePicker.reset();

            nodes.dateStatus.innerText = dateParams.preset.toLowerCase();

            getData();
        })
    }

    return {

        init: function () {

                automationBanner();

            dateParams = {
                preset: "Last 90 days",
                date: null,
            }

            // reset preserved params if user has logged into a different platform account
            let lastPlatform = browser_storage.getItem("platform");

            if(lastPlatform !== platform) {
                browser_storage.removeItem("response-filter-params");
                browser_storage.removeItem("response-date-params");
                browser_storage.removeItem("response-preserve-filters");
                preserveFilters = false;
            }

            browser_storage.setItem("platform", platform);

            initPreserveFilters();
            initSettingsReset();

            optimizedResize.add(() => {

                iterate(document.querySelectorAll(".comment-td") || [], (wrap) => {
                    
                    let node = wrap.querySelector(".contacts-table__comment-block");

                    if (!node) return;

                    requestAnimationFrame(() => {
                        node.style.height = "100%";
                    });

                    requestAnimationFrame(() => {
                        if (node.offsetHeight > 40) {
                            node.style.height = "38px";
                            node.parentNode.querySelector(".nps-link").innerText = "more";
                            wrap.querySelector(".more").style.display = "block";
                        } else {
                            wrap.style.height = "auto";
                            wrap.querySelector(".more").style.display = "none";
                        }
                    });
                });

            });
            
            //flag for remove request in datepicker when reset button clicked
            var resetFlag = false;

            createResponsesTable();

            //init Pagination
            pagination = initPagination(nodes.pagination, function (value) {
                queryParams.page = value;
                getData();
            }, queryParams);

            var releaseSearch = () => {
                nodes.searchField.searchField.disabled = false;
                nodes.searchField.searchField.focus();
            }

            var searchField = initSearchField(nodes.searchField, function (value) {
                nodes.searchField.searchField.disabled = true;
                queryParams["q"] = customEncodeUri(value);
                
                queryParams.page = 1;
                getData(() => {
                    releaseSearch();
                });

            }, {next: queryParams.q});


            let limitNode = document.querySelector(".nps-responses-custom-limit_js");
            limitNode.querySelector("select").value = queryParams.limit + "";

            let DDReset = DD(limitNode, (value) => {
                queryParams["limit"] = value;
                queryParams.page = 1;
                getData();
            });

            var classes = {
                CSV: {
                    btn: ".nps-csv-download_js",
                    filter: ".nps-csv-download-filters_js",
                    noFilter: ".nps-csv-download-no-filters_js",
                    modalContent: ".modal-template-csv_js"
                },
            };

            getFilters(createdModal).then((data) => {
                if (platform === "cw") {
                    data.filters.company_statuses = data.filters.company_statuses || ["active","unactive"];
                }

                iterate(data.filters, (value, key) => {
                    filterData[key] = {
                        values: value,
                        type: "search",
                    }
                    if(preserveFilters === false || preserveFilters === "false") {
                        filterParams[key] = [];
                    }
                });

                if(preserveFilters === "true" || preserveFilters === true) {
                    filterParams = JSON.parse(browser_storage.getItem("response-filter-params"));
                    dateParams = JSON.parse(browser_storage.getItem("response-date-params"));
                }

                renderFilters(data);
                getData(null, true);
            });

            nodes.responsesHeader.addEventListener("click", () => {
                nodes.filterSettingsToggle.classList.contains("active") ? nodes.filterSettingsToggle.classList.remove("active") : nodes.filterSettingsToggle.classList.add("active");
                
                if(nodes.filterSettings.classList.contains("hide")) {
                    nodes.filterSettings.classList.remove("hide");
                    nodes.filterSettingsToggleLabel.innerText = "Hide Filters";
                } else {
                    nodes.filterSettings.classList.add("hide");
                    nodes.filterSettingsToggleLabel.innerText = "Show Filters";
                }
            })            

            //start of init all filters
            dateRangePicker = initDateRangePicker(function (value) {
                dateParams["date"] = value.date;
                dateParams["preset"] = value.preset;

                let status = dateParams.preset ? dateParams.preset.toLowerCase() : `${moment(dateParams.date[0]).format('MMM DD, YYYY')} - ${moment(dateParams.date[1]).format('MMM DD, YYYY')}`;
                nodes.dateStatus.innerText = status;

                queryParams.page = '1';
                getData();
            });

            let presetDateRange = dateRangePicker.getDate();
            dateParams.date = presetDateRange;
            initialDateRange = presetDateRange;

            //init some variables for modal nodes
            var downloadFilter = null;
            var downloadNoFilter = null;

            //button for download csv modal
            var downloadCSVBtn = document.querySelector(classes.CSV.btn);

            downloadCSVBtn.addEventListener("click", function () {
                var content = document.querySelector(classes.CSV.modalContent);
                var title = content.getAttribute("data-title");
                var className = content.getAttribute("data-class");

                let openModal = () => {
                    //Open modal
                    createdModal.open({
                        //set a wrap class for a modal
                        class: className,
                        //set content for a modal
                        content: content.innerHTML,
                        //set title for a modal
                        title: title
                    }, function () {
                        //Bind events when DOM loaded at the modal screen;
                        downloadFilter = document.querySelector(classes.CSV.filter);
                        downloadNoFilter = document.querySelector(classes.CSV.noFilter);
                        downloadFilter.addEventListener("click", downloadCSV);
                        downloadNoFilter.addEventListener("click", downloadCSV);
                    });
                }

                if(dataCacheTimeRemaining > (globals.settings.NPS_CACHE_TTL * 0.1)) {
                    openModal();
                } else {
                    let loaderElement = document.querySelector(".marketing-loader");
                    let hint = loaderElement.querySelector(".loader-bar-wrap_hint");
                    hint.innerText = "Generating CSV for download. Please wait.";
                    loaderElement.classList.remove("disabled");

                    getData(() => {
                        loaderElement.classList.add("disabled");
                        openModal();
                    });
                }
            });

            //function that called when you click how you want to download CSV
            function downloadCSV(event) {
                // var config = encodeToParams(filterParams);
                var url = "";
                if (event.target.getAttribute("data-all")) {
                    url = urls['nps:generate-csv-all']();
                } else {
                    url = urls['nps:generate-csv'](dateParams.date[0], dateParams.date[1]) + "?data=" + encodeURIComponent(JSON.stringify({...filterParams, ...queryParams}));
                }
                window.location.href = url;
                createdModal.close();
            }
        }
    }
}
);